const USER = '[USER]';

export const SET_USER = `${USER} SET`;

export const setUser = data => ({
    type: SET_USER,
    payload: {
        data
    }
});
